'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEntityTypes = exports.getConfig = exports.getFirebase = undefined;

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _capeSelect = require('cape-select');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getFirebase = exports.getFirebase = (0, _get3.default)('firebase');
var getConfig = exports.getConfig = (0, _capeSelect.select)(getFirebase, 'config');
var getEntityTypes = exports.getEntityTypes = (0, _capeSelect.select)(getFirebase, 'entityType');